<template>
  <!-- <ScreenAdapter> -->
  <div>
    <Aside></Aside>
    <Header />
    <div class="container">
      <div class="project-container">
        <div class="project-list">
          <a target="_blank" :href="`/center/${school_code}/custom/party/project?index=${index}`" v-for="item,index in projectList" :key="index">
            <img :src="item.cover">
          </a>
        </div>
      </div>

      <!-- 入党必备 -->
      <div class="join-content">
        <div class="content-header">
          <div class="title">入党必备</div>
          <div class="r-content">
            <div class="category-list">
              <div class="item" v-for="item,index in joinCat" :key="index" @click="jumpList(item,'join')">{{ item.name }}</div>
            </div>
            <div class="more" @click="jumpList('join')">更多</div>
          </div>

        </div>
        <div class="content-box" v-if="joinData&&joinData.length>0">
          <div class="show-cover" @click="jumpDetail(joinData[swiperActive],'join')">
            <div class="img">
              <div class="c-img" :style="`background:url(${joinData[swiperActive].photo}) no-repeat center/cover;`"></div>
            </div>
            <!-- <div class="title">{{ joinData[swiperActive].name }}</div> -->
          </div>
          <div class="swiper">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="item,index in joinData" :key="index" :data-index="index" :data-id="item.id">
                <div class="cover" :data-id="item.id" :class="[swiperActive == index ? 'active' :'' ]">
                  <div class="img" :data-id="item.id">
                    <div class="c-img" :data-id="item.id" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                  </div>
                </div>
              </swiper-slide>
              <!-- <swiper-slide></swiper-slide>
              <swiper-slide></swiper-slide> -->

            </swiper>
            <div class="t swiper-button-next">
              <div class="arrow"></div>
            </div>
            <div class="t swiper-button-prev">
              <div class="arrow"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 党性教育 -->
      <div class="edu-content">
        <div class="content-header">
          <div class="title">党性教育</div>
          <div class="r-content">
            <div class="category-list">
              <div class="item" v-for="item,index in eduCat" :key="index" @click="jumpList(item,'edu')">{{ item.name }}</div>

            </div>
            <div class="more" @click="jumpList('edu')">更多</div>
          </div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item,'edu')" v-for="item,index in eduData" :key="index">
            <div class="img">
              <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`">
              </div>
            </div>
            <!-- <div class="title">{{ item.name }}</div> -->
          </div>
          <div class="flex-hide"></div>
          <div class="flex-hide"></div>
        </div>
      </div>
      <!-- 新思想 新征程 -->
      <div class="new-content">
        <div class="content-inner">
          <div class="content-header">
            <div class="title">新思想 新征程</div>
            <div class="r-content">
              <div class="category-list">
                <div class="item" v-for="item,index in newCat" :key="index" @click="jumpList(item,'new')">{{ item.name }}</div>

              </div>
              <div class="more" @click="jumpList('new')">更多</div>
            </div>
          </div>
          <div class="content-box">
            <div class="main-cover" @click="jumpDetail(item,'new')" v-for="item,index in newData.slice(0,1)" :key="index">
              <div class="img">
                <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
              </div>
              <!-- <div class="title">{{ item.name }}</div> -->
            </div>
            <div class="r-content">
              <div class="item" @click="jumpDetail(item,'new')" v-for="item,index in newData.slice(1,5)" :key="index">
                <div class="img">
                  <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                </div>
                <!-- <div class="title">{{ item.name }}</div> -->
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="f6f6f6">
        <!-- 四史领悟 -->
        <div class="learn-content">
          <div class="content-header">
            <div class="title">四史领悟</div>
            <div class="r-content">
              <div class="category-list">
                <div class="item" v-for="item,index in learnCat" :key="index" @click="jumpList(item,'learn')">{{ item.name }}</div>

              </div>
              <div class="more" @click="jumpList('learn')">更多</div>
            </div>
          </div>
          <div class="content-box">
            <div class="main-cover" @click="jumpDetail(item,'learn')" v-for="item,index in learnData.slice(0,1)" :key="index">
              <div class="img">
                <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
              </div>
              <!-- <div class="title">{{ item.name }}</div> -->
            </div>
            <div class="r-content">
              <div class="item" @click="jumpDetail(item,'learn')" v-for="item,index in learnData.slice(1,7)" :key="index">
                <div class="img">
                  <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                </div>
                <!-- <div class="title">{{ item.name }}</div> -->
              </div>
            </div>

          </div>
        </div>
        <!-- 榜样人物 -->
        <div class="example-content">
          <div class="content-header">
            <div class="title">榜样人物</div>
            <div class="r-content">
              <div class="category-list">
                <div class="item" v-for="item,index in exampleCat" :key="index" @click="jumpList(item,'example')">{{ item.name }}</div>

              </div>
              <div class="more" @click="jumpList('example')">更多</div>
            </div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item,'example')" v-for="item,index in exampleData" :key="index">
              <div class="img">
                <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
              </div>
              <!-- <div class="title">{{ item.name }}</div> -->
            </div>
          </div>
        </div>
        <!-- 地方特色篇 -->
        <div class="local-content">
          <div class="content-header">
            <div class="title">地方特色篇</div>
            <div class="r-content">
              <div class="category-list">
                <div class="item" v-for="item,index in localCat" :key="index" @click="jumpList(item,'local')">{{ item.name }}</div>

              </div>
              <div class="more" @click="jumpList('local')">更多</div>
            </div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item,'local')" v-for="item,index in localData" :key="index">
              <div class="img">
                <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover;`">
                </div>
              </div>
              <!-- <div class="title">{{ item.name }}</div> -->
            </div>
            <div class="flex-hide"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
  <!-- </ScreenAdapter> -->
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import projectData from "../../../assets/js/projectData.js"
import services from '../../../config/services'
import utils from "@/config/utils.js"
import Aside from "../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      swiperActive: 0,
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        direction: 'vertical',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            that.swiperActive = this.realIndex
          },
          click: (e) => {
            let id = e.target.getAttribute("data-id")
            window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=join`)
          },
        },
      },
      joinCat: [],
      eduCat: [],
      newCat: [],
      learnCat: [],
      exampleCat: [],
      localCat: [],

      joinData: [],
      eduData: [],
      newData: [],
      learnData: [],
      exampleData: [],
      localData: [],
      swiper: null,
      category_limit: 5,// 优化：分类限制最多显示5个
      projectList: projectData.projectList,

    }
  },
  async mounted () {
    await this.getCategory()
    await this.getListData()
  },

  methods: {
    // 获取课程分类
    async getCategory () {
      // await services.getCategoryList({ root_id: 0, size: 100, school_code: this.school_code }).then(res => {
      //   console.log(res);
      // })
      try {
        await services.getCategoryList({ root_id: 207, size: this.category_limit, school_code: this.school_code }).then(res => {
          this.joinCat = res.data.slice(0, this.category_limit)
        })

        await services.getCategoryList({ root_id: 211, size: this.category_limit, school_code: this.school_code }).then(res => {
          this.eduCat = res.data.slice(0, this.category_limit)
        })

        await services.getCategoryList({ root_id: 222, size: this.category_limit, school_code: this.school_code }).then(res => {
          this.newCat = res.data.slice(0, this.category_limit)
        })

        await services.getCategoryList({ root_id: 225, size: this.category_limit, school_code: this.school_code }).then(res => {
          this.learnCat = res.data.slice(0, this.category_limit)
        })

        await services.getCategoryList({ root_id: 230, size: this.category_limit, school_code: this.school_code }).then(res => {
          this.exampleCat = res.data.slice(0, this.category_limit)
        })

        await services.getCategoryList({ root_id: 233, size: this.category_limit, school_code: this.school_code }).then(res => {
          this.localCat = res.data.slice(0, this.category_limit)
        })

      } catch (error) {
        console.log(error);
      }
    },
    async getListData () {
      // 入党必备
      await services.getCourseList({ page: 1, size: 100, category_id: "207", school_code: this.school_code }).then(res => {
        this.joinData = res.data.items
      })

      // 党性教育
      await services.getCourseList({ page: 1, size: 8, category_id: "211", school_code: this.school_code }).then(res => {
        this.eduData = res.data.items
      })

      // 新思想 新征程
      await services.getCourseList({ page: 1, size: 5, category_id: "222", school_code: this.school_code }).then(res => {
        this.newData = res.data.items
      })

      // 四史领悟
      await services.getCourseList({ page: 1, size: 7, category_id: "225", school_code: this.school_code }).then(res => {
        this.learnData = res.data.items
      })


      // 榜样人物
      await services.getCourseList({ page: 1, size: 3, category_id: "230", school_code: this.school_code }).then(res => {
        this.exampleData = res.data.items
      })

      // 地方特色篇
      await services.getCourseList({ page: 1, size: 8, category_id: "233", school_code: this.school_code }).then(res => {
        this.localData = res.data.items
      })

    },
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=${key}`, "_blank")
    },

    // 跳转到列表
    jumpList (item, key) {
      if (key) {
        window.open(`/center/${this.school_code}/custom/party/list/${key}?id=${item.id}&key=${key}`, "_blank")
      } else {
        window.open(`/center/${this.school_code}/custom/party/list/${item}`)
      }
    }
  },
  components: {
    Header,
    Footer,
    Aside
    // ScreenAdapter
  }
}
</script>

<style scoped lang="less">
* {
    font-family: Microsoft YaHei;
}
.container {
    background: #fff;
    .content-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        z-index: 10;
        line-height: 1;
        .title {
            font-size: 36px;
            font-family: Source Han Serif SC;
            font-weight: bold;
            color: #fef6c7;
            background: linear-gradient(0deg, #dc1f05 0%, #ff8440 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            &::before {
                content: '';
                display: inline-block;
                width: 6px;
                height: 32px;
                background: linear-gradient(0deg, #de2508 0%, #f97235 100%);
                margin-right: 30px;
                vertical-align: -3px;
            }
        }
        .r-content {
            display: flex;
            align-items: center;
            .category-list {
                display: flex;
                align-items: center;
                .item {
                    font-size: 14px;
                    color: #666666;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: 30px;
                    }
                    &::before {
                        content: '';
                        display: inline-block;
                        margin-right: 6px;
                        width: 4px;
                        height: 4px;
                        background: #d93113;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                }
            }
            .more {
                font-size: 15px;
                font-weight: 400;
                color: #b1000e;
                padding-left: 40px;
                cursor: pointer;
                vertical-align: -1px;
                &::after {
                    content: '';
                    margin-left: 6px;
                    display: inline-block;
                    background: url('../../../assets/custom/party/index/more.png')
                        no-repeat center/cover;
                    width: 12px;
                    height: 13px;
                }
            }
        }
    }
    .content-box {
        position: relative;
        z-index: 10;
    }
    .join-content {
        width: 1200px;
        margin: 0 auto;
        .content-header {
            margin: 40px 0 30px;
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            overflow: hidden;
            .show-cover {
                flex-shrink: 0;
                width: 915px;
                height: 470px;
                cursor: pointer;
                position: relative;
                z-index: 10;
                .img {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    .c-img {
                        transition: all 0.7s;
                        width: 100%;
                        height: 100%;
                    }
                    &:hover .c-img {
                        transform: scale(1.2);
                    }
                }

                .title {
                    width: 625px;
                    font-size: 16px;
                    font-weight: bold;
                    color: #ffffff;
                    position: relative;
                    padding: 0 150px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: 50px;
                    line-height: 50px;
                    margin: 0 auto;
                    text-align: center;
                    &::before,
                    &::after {
                        content: '';
                        display: inline-block;
                        width: 131px;
                        height: 41px;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                    &::before {
                        background: url('../../../assets/custom/party/index/text-l.png')
                            no-repeat center/cover;
                        left: 0;
                    }
                    &::after {
                        background: url('../../../assets/custom/party/index/text-r.png')
                            no-repeat center/cover;
                        right: 0;
                    }
                }
            }
            .swiper {
                width: 285px;
                height: 470px;
                overflow: hidden;
                padding: 38px 0 38px 0;
                position: relative;
                flex-shrink: 0;
                .swiper-slide {
                    cursor: pointer;
                    padding-left: 15px;
                    // height: 160px !important;
                    // margin-bottom: 10px !important;
                    &.swiper-slide-active {
                        .cover {
                            border: 2px solid #ad1c28;
                            box-shadow: 0px 0px 10px 0px rgba(77, 77, 77, 0.5);
                            &::before {
                                content: '';
                                display: inline-block;
                                width: 15px;
                                height: calc(100% + 5px);
                                background: #b1000e;
                                position: absolute;
                                top: 50%;
                                left: -17px;
                                transform: translateY(-50%);
                            }
                        }
                    }
                    .cover {
                        width: 100%;
                        // height: 160px;
                        height: 100%;
                        position: relative;
                        border: 1px solid transparent;
                        transition: transform 0.3s;
                        &.active {
                        }
                        .img {
                            overflow: hidden;
                            width: 100%;
                            height: 100%;
                        }
                        .img:hover .c-img {
                            transform: scale(1.2);
                        }
                        .c-img {
                            transition: transform 0.7s;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                ::v-deep .swiper-container,
                ::v-deep .swiper-container-vertical > .swiper-wrapper {
                    width: 100% !important;
                    height: 100% !important;
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev,
                ::v-deep .swiper-button-next {
                    width: 100%;
                    height: 30px;
                    background: #b1000e;
                    position: absolute;
                    left: 12px;
                    cursor: pointer;
                    .arrow {
                        width: 16px;
                        height: 9px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                ::v-deep .swiper-button-prev {
                    top: 0;
                    .arrow {
                        background: url('../../../assets/custom/party/index/swiper-arrow.png')
                            no-repeat center/cover;
                        transform: translate(-10px, -5px) rotateZ(180deg);
                    }
                }
                ::v-deep .swiper-button-next {
                    bottom: 0;
                    .arrow {
                        background: url('../../../assets/custom/party/index/swiper-arrow.png')
                            no-repeat center/cover;
                        transform: translate(-10px, -3px);
                    }
                }
                ::v-deep .swiper-button-disabled {
                    cursor: not-allowed;
                    opacity: 0.7;
                }
            }
        }
    }
    .edu-content,
    .local-content {
        width: 1200px;
        margin: 0 auto;
        margin: 0 0 10px;
        .content-header {
            margin: 45px 0 30px;
        }
        .content-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .flex-hide {
                flex: 0 0 280px;
                display: inline-block;
                visibility: hidden;
            }
            .item {
                width: 280px;
                height: 157px;
                cursor: pointer;
                margin-bottom: 30px;

                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                    .title {
                        color: #b1000e;
                    }
                }
                .c-img {
                    transition: all 0.7s;
                    width: 100%;
                    height: 100%;
                }
                .img {
                    width: 100%;
                    height: 157px;
                    overflow: hidden;
                }
                .title {
                    width: 100%;
                    font-size: 16px;
                    color: #020718;
                    line-height: 1;
                    padding-top: 14px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    .new-content,
    .learn-content {
        padding: 40px 0 38px;
        position: relative;
        .content-header {
            margin: 0 0 30px;
            .title {
                background: unset;
                -webkit-text-fill-color: unset;
                &::before {
                    background: #fef6c7;
                }
            }
            .category-list {
                .item {
                    color: #ffffff;
                    &::before {
                        vertical-align: 2px;
                        background: #ffffff;
                    }
                }
            }
            .more {
                color: #ffffff;
                &::after {
                    background: url('../../../assets/custom/party/index/more-w.png')
                        no-repeat center/cover;
                }
            }
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            .main-cover {
                width: 612px;
                height: 344px;
                cursor: pointer;
                flex-shrink: 0;
                margin-right: 14px;
                &:hover {
                    .title {
                        color: #b1000e;
                    }
                    .c-img {
                        transform: scale(1.2);
                    }
                }
                .title {
                    width: 100%;
                    line-height: 50px;
                    height: 50px;
                    background: #ffffff;
                    padding: 0 21px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    position: relative;
                    &::before {
                        content: '';
                        display: inline-block;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 6px;
                        height: 18px;
                        background: #fccc8d;
                    }
                }
                .img {
                    width: 100%;
                    height: 344px;
                    overflow: hidden;
                    .c-img {
                        width: 100%;
                        height: 100%;
                        transition: all 0.7s;
                    }
                }
            }
            .r-content {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                align-content: space-between;
                .item {
                    cursor: pointer;
                    width: 280px;

                    &:hover {
                        .c-img {
                            transform: scale(1.2);
                        }
                        .title {
                            color: #b1000e;
                        }
                    }
                    .img {
                        width: 100%;
                        height: 158px;
                        overflow: hidden;
                        .c-img {
                            width: 100%;
                            height: 100%;
                            transition: all 0.7s;
                        }
                    }
                    .title {
                        width: 100%;
                        height: 32px;
                        line-height: 32px;
                        background: #ffffff;
                        padding: 0 10px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
    .learn-content {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 0;

        .content-header {
            .title {
                color: #fef6c7;
                background: linear-gradient(0deg, #dc1f05 0%, #ff8440 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                &::before {
                    background: linear-gradient(0deg, #de2508 0%, #f97235 100%);
                }
            }
            .more {
                color: #b1000e;
                &::after {
                    background: url('../../../assets/custom/party/index/more.png')
                        no-repeat center/cover;
                }
            }
            .category-list {
                .item {
                    color: #666666;
                    &::before {
                        background: #d93113;
                    }
                }
            }
        }

        .content-box {
            .main-cover {
                width: 480px;
                height: 270px;
                margin-right: 18px;
                .img {
                    height: 100%;
                }
                .title {
                    height: auto;
                    line-height: 1;
                    padding-top: 14px;
                    &::before {
                        display: none;
                    }
                }
            }
            .r-content {
                .item {
                    width: 222px;
                    .img {
                        height: 125px;
                    }
                    .title {
                        height: auto;
                        line-height: 1;
                        padding: 14px 0 0;
                    }
                }
            }
        }
    }
    .example-content {
        width: 1200px;
        margin: 0 auto;
        .content-header {
            margin: 50px 0 30px;
        }
        .content-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item {
                width: 585px;
                cursor: pointer;
                &:hover {
                    .title {
                        color: #b1000e;
                    }
                    .c-img {
                        transform: scale(1.2);
                    }
                }
                .img {
                    width: 100%;
                    height: 329px;
                    overflow: hidden;
                    .c-img {
                        width: 100%;
                        height: 100%;
                        transition: all 0.7s;
                    }
                }
                .title {
                    width: 100%;
                    height: 40px;
                    background: #ffffff;
                    line-height: 40px;
                    font-size: 14px;
                    color: #020718;
                }
            }
            .flex-hide {
                flex: 0 0 580px;
                visibility: hidden;
                display: inline-block;
            }
        }
    }
    .new-content {
        width: 100%;
        height: 100%;
        background: #b1000e;
        .content-inner {
            width: 1200px;
            margin: 0 auto;
        }
    }
    .edu-content,
    .local-content {
        width: 1200px;
        margin: 0 auto;
    }
    .project-container {
        background: #fafafa;
        padding: 30px 0;
        .project-list {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            a {
                width: 280px;
                height: 96px;
                overflow: hidden;
                img {
                    transition: scale 0.5s;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                &:hover {
                    img {
                        scale: 1.2;
                    }
                }
            }
        }
    }
}
.f6f6f6 {
    background: #f6f6f6;
}
</style>